import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";

export const MODULE = "Record";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $put = ActionCreator.Async(MODULE, "Put", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/post/record`, payload)
      .then((response) => {
        dispatch($put.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});
